import { createSlice } from "@reduxjs/toolkit";

const manageSurveyorSlice = createSlice({
  name: "manage_surveyor_slice",
  initialState: {
    filter: {
      statusFilterList: {},
      withOnboardedArea: false,
      regionFilterList: {
        state: [],
        district: [],
        block: [],
      },
      agentFilterList: [],
    },
  },

  reducers: {
    updateFilter: (state, action) => {
      const { regionFilterList, agentFilterList, withOnboardedArea } =
        action.payload.data;
      state.filter.withOnboardedArea = withOnboardedArea;
      state.filter.regionFilterList = regionFilterList;
      state.filter.agentFilterList = agentFilterList;
    },

    resetRegionFilterList: (state) => {
      state.filter.regionFilterList = {
        state: [],
        district: [],
        block: [],
      };
    },
    resetFilter: (state) => {
      state.filter = {
        statusFilterList: {},
        withOnboardedArea: false,
        regionFilterList: {
          state: [],
          district: [],
          block: [],
        },
        agentFilterList: [],
      };
    },
    resetOnBoardedAreaFilter: (state) => {
      state.filter.withOnboardedArea = false;
    },

    updateAgentFilterList: (state, action) => {
      state.filter.agentFilterList = action.payload.data;
    },
  },
});

export const {
  updateAgentFilterList,
  updateFilter,
  resetRegionFilterList,
  resetOnBoardedAreaFilter,
  resetFilter,
} = manageSurveyorSlice.actions;
export default manageSurveyorSlice.reducer;
